module.exports = __webpack_public_path__ + "assets/img/bb5e05b89499810ccf2a3e6f79db2e8b.jpg";